import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c4ab8df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-plus fas" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_list_component = _resolveComponent("user-list-component")!
  const _component_user_registration_component = _resolveComponent("user-registration-component")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_page_buttons_component = _resolveComponent("page-buttons-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_user_list_component, {
        ref: "userList",
        canWrite: _ctx.listCanWrite,
        detailRouterName: "adminContainerDetail"
      }, null, 8, ["canWrite"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showUserForm,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showUserForm) = $event)),
      title: _ctx.$t(_ctx.userForm?.id ? 'label.userEdit' : 'label.userNew'),
      width: "50%",
      "destroy-on-close": "",
      "custom-class": "app-form"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeUserFormDialog()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.previous())),
            disabled: _ctx.active === 0
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.previous")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.next())),
            disabled: _ctx.active == 2
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.next")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveUser()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_user_registration_component, {
          ref: "userForm",
          active: _ctx.active
        }, null, 8, ["active"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_page_buttons_component, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_tooltip, {
          class: "box-item",
          effect: "dark",
          content: _ctx.$t('btn.create'),
          placement: "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "btn",
              type: "primary",
              size: "large",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openUserFormDialog())),
              circle: ""
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      _: 1
    })
  ]))
}